(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vw-category-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  var s = (document.currentScript && document.currentScript.closest('.vw-category-products')) || document.querySelector('.vw-category-products');
  if (!s) return;

  function listAttr(el, name) {
    var raw = el.getAttribute(name);
    if (!raw) return null;
    var out = raw.split('||').filter(Boolean);
    return out.length ? out : null;
  }

  // Metafield payload for the quick view: /products/<handle>.js cannot return
  // metafields, so hand them over from Liquid on the card element. The key names
  // are the ones snippets/vw-quick-view.liquid reads (speciesGallery drives the
  // species photo swap; speciesPricing re-prices per selected species;
  // comingSoon swaps the buy row for the lead-time note).
  function metaFor(card) {
    var gallery = null;
    var rawGallery = card.getAttribute('data-species-gallery');
    if (rawGallery) { try { gallery = JSON.parse(rawGallery); } catch (err) { gallery = null; } }
    var pricing = null;
    var rawPricing = card.getAttribute('data-species-pricing');
    if (rawPricing) { try { pricing = JSON.parse(rawPricing); } catch (err) { pricing = null; } }
    return {
      category: card.getAttribute('data-category') || '',
      maker: card.getAttribute('data-maker') || '',
      provenance: card.getAttribute('data-provenance') || '',
      dimensions: card.getAttribute('data-dimensions') || '',
      leadTime: card.getAttribute('data-lead-time') || '',
      materials: listAttr(card, 'data-materials'),
      finishes: listAttr(card, 'data-finishes'),
      speciesGallery: gallery,
      speciesPricing: pricing,
      comingSoon: card.getAttribute('data-coming-soon') === '1'
    };
  }

  s.addEventListener('click', function (e) {
    var fav = e.target.closest('[data-vw-fav]');
    if (fav && s.contains(fav)) {
      var on = fav.getAttribute('aria-pressed') === 'true';
      fav.setAttribute('aria-pressed', on ? 'false' : 'true');
      return;
    }

    var add = e.target.closest('[data-vw-quickadd]');
    if (add && s.contains(add)) {
      var id = add.getAttribute('data-variant');
      if (!id) return;
      add.setAttribute('disabled', '');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      }).then(function () {
        document.dispatchEvent(new CustomEvent('vw:cart-changed', { bubbles: true }));
      }).catch(function () {}).then(function () {
        add.removeAttribute('disabled');
      });
      return;
    }

    var link = e.target.closest('[data-vw-quickview]');
    if (!link || !s.contains(link)) return;
    var handle = link.getAttribute('data-handle');
    if (!handle) return;
    var card = link.closest('[data-card]');
    // Dispatch a cancelable quick-view event. The quick-view snippet calls
    // preventDefault() on it (dispatchEvent returns false) and we suppress the
    // link navigation. With no handler the <a> falls back to the product page.
    var ev = new CustomEvent('vw:quickview', {
      detail: { handle: handle, meta: card ? metaFor(card) : null },
      bubbles: true,
      cancelable: true
    });
    var proceeded = document.dispatchEvent(ev);
    if (!proceeded) { e.preventDefault(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vw-collection-cover"] && !Shopify.designMode) return;
  try {
    
(function () {
  var s = (document.currentScript && document.currentScript.closest('.vw-collection-cover')) || document.querySelector('.vw-collection-cover');
  if (!s) return;

  var rows = Array.prototype.slice.call(s.querySelectorAll('.vw-cc-row'));
  var imgs = Array.prototype.slice.call(s.querySelectorAll('.vw-cc-stage__img'));
  var explore = s.querySelector('[data-explore]');
  var exploreLabel = s.querySelector('[data-explore-label]');
  var explorePrefix = exploreLabel ? (exploreLabel.getAttribute('data-prefix') || '') : '';
  if (!rows.length) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DURATION = reduce ? 0 : 550;

  var current = 0;   // index currently mounted in the stage
  var pending = null; // AnimatePresence mode="wait" queues the LATEST key
  var busy = false;
  var timer = null;

  function stageFor(i) {
    for (var n = 0; n < imgs.length; n++) {
      if (parseInt(imgs[n].getAttribute('data-stage'), 10) === i) return imgs[n];
    }
    return null;
  }

  // When the exit finishes, AnimatePresence mounts whatever key is current at
  // that moment — not the one that was queued first. `pending` reproduces that.
  function mount(target) {
    var t = (pending !== null) ? pending : target;
    pending = null;
    var next = stageFor(t);
    if (next) next.classList.add('is-active');
    current = t;
    busy = false;
  }

  // AnimatePresence mode="wait": the outgoing element finishes its exit
  // (opacity -> 0) before the incoming one mounts and plays its enter
  // (opacity 0 -> 1, scale 1.06 -> 1). Both legs run at 550ms / [.22,1,.36,1].
  function swapTo(i) {
    if (i === current && !busy) return;
    if (busy) { pending = i; return; }
    busy = true;
    var prev = stageFor(current);
    if (timer) clearTimeout(timer);
    if (prev) prev.classList.remove('is-active');
    if (DURATION === 0) { mount(i); return; }
    timer = setTimeout(function () { mount(i); }, DURATION);
  }

  function setActive(i, row) {
    rows.forEach(function (r) { r.classList.remove('is-active'); });
    row.classList.add('is-active');
    if (explore) {
      var href = row.getAttribute('data-href') || '#';
      explore.setAttribute('href', href);
    }
    if (exploreLabel) {
      exploreLabel.textContent = explorePrefix + ' ' + (row.getAttribute('data-name') || '');
    }
    swapTo(i);
  }

  rows.forEach(function (row) {
    var i = parseInt(row.getAttribute('data-tile'), 10) || 0;
    row.addEventListener('mouseenter', function () { setActive(i, row); });
    row.addEventListener('focus', function () { setActive(i, row); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vw-collection-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('.vw-collection-products');
  var s = (document.currentScript && document.currentScript.closest('.vw-collection-products')) || sections[0];
  if (!s) return;
  if (s.hasAttribute('data-vw-bound')) return;

  function listAttr(el, name) {
    var raw = el.getAttribute(name);
    if (!raw) return null;
    var out = raw.split('||').filter(Boolean);
    return out.length ? out : null;
  }

  // Metafield payload for the quick view: /products/<handle>.js cannot return
  // metafields, so hand them over from Liquid on the card element. Key names
  // match sections/vw-home-collection.liquid exactly — snippets/vw-quick-view
  // reads meta.speciesGallery (species photo swap + filter) and meta.comingSoon.
  function metaFor(card) {
    var gallery = null;
    var rawGallery = card.getAttribute('data-species-gallery');
    if (rawGallery) { try { gallery = JSON.parse(rawGallery); } catch (e) { gallery = null; } }
    return {
      category: card.getAttribute('data-category') || '',
      maker: card.getAttribute('data-maker') || '',
      provenance: card.getAttribute('data-provenance') || '',
      dimensions: card.getAttribute('data-dimensions') || '',
      leadTime: card.getAttribute('data-lead-time') || '',
      materials: listAttr(card, 'data-materials'),
      finishes: listAttr(card, 'data-finishes'),
      speciesGallery: gallery,
      comingSoon: card.getAttribute('data-coming-soon') === '1'
    };
  }

  // This section type is placed three times on the page; bind each instance once.
  Array.prototype.forEach.call(sections, function (root) {
    if (root.hasAttribute('data-vw-bound')) return;
    root.setAttribute('data-vw-bound', '');

    Array.prototype.forEach.call(root.querySelectorAll('[data-card]'), function (card) {
      var media = card.querySelector('[data-quickview]');
      if (media) {
        media.addEventListener('click', function (e) {
          var ev = new CustomEvent('vw:quickview', {
            detail: { handle: media.getAttribute('data-quickview'), meta: metaFor(card) },
            cancelable: true,
            bubbles: true
          });
          // If the quick view handles (and cancels) the event, stay on the page;
          // otherwise the anchor navigates to the product — the no-JS path.
          if (!document.dispatchEvent(ev)) e.preventDefault();
        });
      }

      var fav = card.querySelector('[data-fav]');
      if (fav) {
        fav.addEventListener('click', function () {
          var on = fav.getAttribute('aria-pressed') === 'true';
          fav.setAttribute('aria-pressed', on ? 'false' : 'true');
        });
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vw-custom-configurator"] && !Shopify.designMode) return;
  try {
    
/* Scroll affordance for the two rows that scroll inside their own container on
   a phone: the family tabs and the camera-view pills. This only toggles the
   classes that fade the right edge in and out so each row reads as scrollable
   and the fade disappears at the end of the run. The PAGE never scrolls
   sideways because of them. Nothing here touches the three.js boot in the
   module script block. */
(function () {
  var s = (document.currentScript && document.currentScript.closest('.vw-custom-configurator')) || document.querySelector('.vw-custom-configurator');
  if (!s) return;

  function wire(wrapSel, railSel) {
    var wrap = s.querySelector(wrapSel);
    var rail = s.querySelector(railSel);
    if (!wrap || !rail) return;

    function sync() {
      var max = rail.scrollWidth - rail.clientWidth;
      if (max > 4) {
        wrap.classList.add('is-scrollable');
      } else {
        wrap.classList.remove('is-scrollable');
      }
      if (rail.scrollLeft >= max - 4) {
        wrap.classList.add('at-end');
      } else {
        wrap.classList.remove('at-end');
      }
    }

    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    if (window.ResizeObserver) {
      try { new ResizeObserver(sync).observe(rail); } catch (e) {}
    }
    sync();
  }

  wire('.vw-cc__tabs-wrap', '.vw-cc__tabs');
  wire('.vw-cc__views-wrap', '.vw-cc__views');
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vw-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  var s = (document.currentScript && document.currentScript.closest('.vw-header')) || document.querySelector('.vw-header');
  if (!s) return;

  var burger = s.querySelector('[data-vw-burger]');
  var mobile = s.querySelector('[data-vw-mobile]');
  var mclose = s.querySelector('[data-vw-mclose]');
  var openIcon = s.querySelector('.vw-header__burger-open');
  var closeIcon = s.querySelector('.vw-header__burger-close');

  function setMenu(open) {
    if (open) {
      mobile.removeAttribute('hidden');
      openIcon.setAttribute('hidden', '');
      closeIcon.removeAttribute('hidden');
    } else {
      mobile.setAttribute('hidden', '');
      closeIcon.setAttribute('hidden', '');
      openIcon.removeAttribute('hidden');
    }
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    s.classList.toggle('is-menu-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }

  if (burger && mobile) {
    burger.addEventListener('click', function () { setMenu(mobile.hasAttribute('hidden')); });
    // Four independent ways out: the burger, the bottom close button (thumb zone),
    // Escape, and tapping any link. The panel must never be a trap.
    if (mclose) {
      mclose.addEventListener('click', function () { setMenu(false); burger.focus(); });
    }
    mobile.addEventListener('click', function (e) {
      if (e.target.closest('a')) setMenu(false);
    });
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && !mobile.hasAttribute('hidden')) {
        setMenu(false);
        burger.focus();
      }
    });
    window.addEventListener('resize', function () {
      // Rotating to a width where the burger is display:none must not strand the panel.
      if (window.innerWidth > 1299 && !mobile.hasAttribute('hidden')) setMenu(false);
    }, { passive: true });
  }

  // Search icon -> full-screen overlay (snippets/vw-search-overlay.liquid).
  // Closes the mobile menu first, like Navigation.tsx; stays a plain /search
  // link when the overlay is not on the page.
  var searchBtn = s.querySelector('[data-vw-search-open]');
  if (searchBtn) {
    searchBtn.addEventListener('click', function (e) {
      if (!document.querySelector('[data-vw-search-overlay]')) return;
      e.preventDefault();
      if (burger && mobile && !mobile.hasAttribute('hidden')) setMenu(false);
      document.dispatchEvent(new CustomEvent('vw:search-open'));
    });
  }

  // Sticky background + light/dark swap, matching Navigation.tsx: probes any
  // [data-nav-theme] element crossing the header's baseline (y=72) and flips
  // the header to its dark variant when that element declares dark="true".
  var raf = 0;
  function onScroll() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () {
      s.classList.toggle('is-scrolled', window.scrollY > 50);
      var probes = document.querySelectorAll('[data-nav-theme]');
      var dark = false;
      for (var i = 0; i < probes.length; i++) {
        var r = probes[i].getBoundingClientRect();
        if (r.top <= 72 && r.bottom >= 72) {
          dark = probes[i].getAttribute('data-nav-theme') === 'dark';
          break;
        }
      }
      s.classList.toggle('is-dark', dark);
    });
  }
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vw-home-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  var s = (document.currentScript && document.currentScript.closest('.vw-home-collection')) || document.querySelector('.vw-home-collection');
  if (!s) return;
  var grid = s.querySelector('[data-vw-grid]');
  if (!grid) return;
  var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-card]'));
  var tabs = Array.prototype.slice.call(s.querySelectorAll('.vw-hc-tab'));
  var sortSel = s.querySelector('[data-vw-sort]');
  var countEl = s.querySelector('[data-vw-count-target]');
  var origin = cards.slice();
  var currentFilter = 'all';

  function listAttr(el, name) {
    var raw = el.getAttribute(name);
    if (!raw) return null;
    var out = raw.split('||').filter(Boolean);
    return out.length ? out : null;
  }

  // Metafield payload for the quick view: /products/<handle>.js cannot return
  // metafields, so hand them over from Liquid on the card element.
  function metaFor(card) {
    var gallery = null;
    var rawGallery = card.getAttribute('data-species-gallery');
    if (rawGallery) { try { gallery = JSON.parse(rawGallery); } catch (e) { gallery = null; } }
    return {
      category: card.getAttribute('data-category') || '',
      maker: card.getAttribute('data-maker') || '',
      provenance: card.getAttribute('data-provenance') || '',
      dimensions: card.getAttribute('data-dimensions') || '',
      leadTime: card.getAttribute('data-lead-time') || '',
      materials: listAttr(card, 'data-materials'),
      finishes: listAttr(card, 'data-finishes'),
      speciesGallery: gallery,
      comingSoon: card.getAttribute('data-coming-soon') === '1'
    };
  }

  // Quick view — dispatch cancelable event; if unhandled, the anchor navigates
  // to the product page (fallback).
  cards.forEach(function (card) {
    var media = card.querySelector('.vw-hc-media');
    if (!media) return;
    media.addEventListener('click', function (e) {
      var handle = media.getAttribute('data-quickview');
      var ev = new CustomEvent('vw:quickview', { detail: { handle: handle, meta: metaFor(card) }, cancelable: true, bubbles: true });
      var proceeded = document.dispatchEvent(ev);
      if (!proceeded) e.preventDefault();
    });
    var fav = card.querySelector('[data-fav]');
    if (fav) {
      fav.addEventListener('click', function () {
        var on = fav.getAttribute('aria-pressed') === 'true';
        fav.setAttribute('aria-pressed', on ? 'false' : 'true');
      });
    }
  });

  function visibleCards() {
    return origin.filter(function (c) { return !c.hasAttribute('hidden'); });
  }

  // Recompute the positional "featured" (wide) card: index 0 and every 7th
  // visible card spans two columns, matching the React `i % 7 === 0` rule.
  function relayoutFeatured() {
    var vis = visibleCards();
    vis.forEach(function (c, i) {
      if (i % 7 === 0) c.classList.add('is-featured');
      else c.classList.remove('is-featured');
    });
  }

  function applyFilter() {
    var shown = 0;
    origin.forEach(function (c) {
      var match = currentFilter === 'all' || c.getAttribute('data-category') === currentFilter;
      if (match) { c.removeAttribute('hidden'); shown++; }
      else c.setAttribute('hidden', '');
    });
    if (countEl) countEl.textContent = shown;
    relayoutFeatured();
  }

  function applySort() {
    var mode = sortSel ? sortSel.value : 'featured';
    var arr = origin.slice();
    if (mode === 'newest') {
      arr.sort(function (a, b) { return (parseInt(b.getAttribute('data-new'), 10) || 0) - (parseInt(a.getAttribute('data-new'), 10) || 0); });
    } else if (mode === 'price-asc') {
      arr.sort(function (a, b) { return (parseInt(a.getAttribute('data-price'), 10) || 0) - (parseInt(b.getAttribute('data-price'), 10) || 0); });
    } else if (mode === 'price-desc') {
      arr.sort(function (a, b) { return (parseInt(b.getAttribute('data-price'), 10) || 0) - (parseInt(a.getAttribute('data-price'), 10) || 0); });
    } else {
      arr = cards.slice();
    }
    arr.forEach(function (c) { grid.appendChild(c); });
    origin = arr;
    relayoutFeatured();
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      currentFilter = tab.getAttribute('data-filter');
      applyFilter();
    });
  });

  if (sortSel) sortSel.addEventListener('change', function () { applySort(); applyFilter(); });

  relayoutFeatured();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vw-home-craft"] && !Shopify.designMode) return;
  try {
    
(function () {
  var s = (document.currentScript && document.currentScript.closest('.vw-home-craft')) || document.querySelector('.vw-home-craft');
  if (!s || s.dataset.craftBound) return;
  s.dataset.craftBound = '1';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var chapters = Array.prototype.slice.call(s.querySelectorAll('[data-chapter]'));
  var slides = Array.prototype.slice.call(s.querySelectorAll('[data-slide]'));
  var ticks = Array.prototype.slice.call(s.querySelectorAll('[data-tick]'));
  var imgs = Array.prototype.slice.call(s.querySelectorAll('[data-craft-img]'));
  var badge = s.querySelector('[data-craft-badge]');
  var badgeNum = s.querySelector('[data-craft-badge-num]');
  var badgeTitle = s.querySelector('[data-craft-badge-title]');
  var captionNum = s.querySelector('[data-craft-caption-num]');
  var bar = s.querySelector('[data-craft-bar]');
  var total = chapters.length;
  var active = -1;
  var swapTimer = null;

  function toggle(list, i) {
    for (var c = 0; c < list.length; c++) {
      if (c === i) list[c].classList.add('is-active');
      else list[c].classList.remove('is-active');
    }
  }

  function writeBadge(num, title) {
    if (badgeNum) badgeNum.textContent = num;
    if (badgeTitle) badgeTitle.textContent = title;
  }

  function setActive(i) {
    if (i === active || i < 0 || i >= total) return;
    var firstRun = active === -1;
    active = i;

    toggle(chapters, i);
    toggle(slides, i);
    toggle(ticks, i);

    for (var d = 0; d < slides.length; d++) {
      if (d === i) slides[d].removeAttribute('aria-hidden');
      else slides[d].setAttribute('aria-hidden', 'true');
    }

    var el = chapters[i];
    var num = el.getAttribute('data-number');
    var title = el.getAttribute('data-title');
    if (captionNum) captionNum.textContent = num;
    if (bar && total > 0) bar.style.width = ((i + 1) / total * 100).toFixed(2) + '%';

    // chapter pill: exit up, swap, enter from below (React AnimatePresence, .25s)
    if (reduce || firstRun || !badge) {
      writeBadge(num, title);
      return;
    }
    if (swapTimer) clearTimeout(swapTimer);
    badge.classList.remove('is-in');
    badge.classList.add('is-out');
    swapTimer = setTimeout(function () {
      writeBadge(num, title);
      badge.classList.remove('is-out');
      badge.classList.add('is-in');
      // force a reflow so the enter transition actually runs
      void badge.offsetWidth;
      badge.classList.remove('is-in');
    }, 250);
  }

  // Active-chapter band tracking: React viewport margin -45% top/bottom
  // = element crosses the middle 10% band of the viewport.
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var idx = parseInt(entry.target.getAttribute('data-index'), 10);
          if (!isNaN(idx)) setActive(idx);
        }
      });
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
    chapters.forEach(function (c) { io.observe(c); });
  }
  setActive(0);

  // Mobile overlaps the media column and the chapter list in one grid cell so the
  // photo has something to stay pinned against (see the max-width:767px block in
  // the CSS). That overlap means the list has to be pushed down past the photo by
  // hand — measure it rather than trusting the calc() fallback, which cannot know
  // the caption's real height at this viewport.
  var mediaCol = s.querySelector('.vw-home-craft__media-col');
  if (mediaCol) {
    var setCraftOffset = function () {
      if (window.matchMedia('(min-width: 768px)').matches) {
        s.style.removeProperty('--vw-craft-offset');
        return;
      }
      var h = mediaCol.getBoundingClientRect().height;
      /* Clamp. This offset pushes the chapter copy down, so an over-reading is
         not a small cosmetic error -- it buries the text below the fold behind a
         wall of empty background, which is exactly what shipped once. The media
         is a 16:10 frame plus a caption row, so it can never legitimately exceed
         about 85% of the viewport; anything larger means we measured a stretched
         box and the CSS fallback is the safer answer. */
      var cap = window.innerHeight * 0.85;
      if (!(h > 0) || h > cap) { s.style.removeProperty('--vw-craft-offset'); return; }
      s.style.setProperty('--vw-craft-offset', Math.round(h + 28) + 'px');
    };
    setCraftOffset();
    window.addEventListener('resize', setCraftOffset);
    // the photo is most of the offset, so remeasure once it has decoded
    for (var q = 0; q < imgs.length; q++) {
      if (!imgs[q].complete) imgs[q].addEventListener('load', setCraftOffset, { once: true });
    }
  }

  // Parallax on the sticky media (React: y -5% -> 5% across the frame's pass).
  if (!reduce && imgs.length) {
    var frame = s.querySelector('.vw-home-craft__frame');
    var ticking = false;
    function apply() {
      ticking = false;
      if (!frame) return;
      var r = frame.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      // progress 0 when frame top at viewport bottom, 1 when frame bottom at top
      var p = (vh - r.top) / (vh + r.height);
      if (p < 0) p = 0; else if (p > 1) p = 1;
      var y = (-5 + 10 * p).toFixed(2);
      for (var k = 0; k < imgs.length; k++) {
        imgs[k].style.transform = 'translateY(' + y + '%)';
      }
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(apply); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    apply();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vw-home-interior-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  var s = (document.currentScript && document.currentScript.closest('.vw-home-igallery')) || document.querySelector('.vw-home-igallery');
  if (!s || s.dataset.igBound) return;
  s.dataset.igBound = '1';

  var rail = s.querySelector('[data-rail]');
  var cards = Array.prototype.slice.call(s.querySelectorAll('[data-card]'));

  // --- open project detail via shared modal ---
  function openCard(card) {
    var id = card.getAttribute('data-open-project');
    var src = s.querySelector('[data-modal-source="' + id + '"]');
    if (src && window.vwModal) window.vwModal.open(src);
  }
  cards.forEach(function (card) {
    card.addEventListener('click', function () { openCard(card); });
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openCard(card); }
    });
  });

  // --- delegated quick-view + add-to-bag (works on cloned modal markup) ---
  if (!window.__vwIGalleryDelegated) {
    window.__vwIGalleryDelegated = true;
    document.addEventListener('click', function (e) {
      var qv = e.target.closest && e.target.closest('[data-vw-qv]');
      if (qv) {
        var handle = qv.getAttribute('data-handle');
        if (handle) document.dispatchEvent(new CustomEvent('vw:quickview', { detail: { handle: handle } }));
        return;
      }
      var add = e.target.closest && e.target.closest('[data-vw-add]');
      if (add) {
        var vid = add.getAttribute('data-variant');
        if (!vid) return;
        var props = {};
        var mat = add.getAttribute('data-material');
        var fin = add.getAttribute('data-finish');
        if (mat) props['Material'] = mat;
        if (fin) props['Finish'] = fin;
        add.setAttribute('disabled', '');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: vid, quantity: 1, properties: props })
        }).then(function (r) { return r.json(); }).then(function () {
          document.dispatchEvent(new CustomEvent('vw:cart-changed'));
        }).catch(function () {}).then(function () {
          add.removeAttribute('disabled');
        });
      }
    });
  }

  // --- pinned horizontal scrub (GSAP ScrollTrigger), else static swipe rail ---
  var mqDesktop = window.matchMedia('(min-width: 768px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var st = null;

  function killST() { if (st) { st.kill(); st = null; } }

  function applyStatic() {
    killST();
    s.classList.add('is-static');
    if (rail) rail.style.transform = '';
    cards.forEach(function (c) {
      c.style.transform = '';
      c.style.filter = '';
      var cap = c.querySelector('[data-caption]');
      if (cap) cap.style.opacity = '';
    });
  }

  function buildST() {
    if (!window.gsap || !window.ScrollTrigger || !rail) return;
    s.classList.remove('is-static');
    window.gsap.registerPlugin(window.ScrollTrigger);
    var getDistance = function () { return Math.max(0, rail.scrollWidth - window.innerWidth); };
    st = window.ScrollTrigger.create({
      trigger: s,
      start: 'top top',
      end: 'bottom bottom',
      scrub: 0.9,
      onUpdate: function (self) {
        var d = getDistance();
        window.gsap.set(rail, { x: -d * self.progress });
        var cx = window.innerWidth / 2;
        cards.forEach(function (card) {
          var r = card.getBoundingClientRect();
          var center = r.left + r.width / 2;
          var t = Math.min(1, Math.abs(center - cx) / (window.innerWidth * 0.6));
          var sc = 1 - t * 0.06;
          card.style.transform = 'scale(' + sc + ')';
          card.style.filter = 'saturate(' + (100 - t * 45) + '%)';
          var cap = card.querySelector('[data-caption]');
          if (cap) cap.style.opacity = String(1 - t * 0.65);
        });
      }
    });
  }

  function decide() {
    if (reduce || !mqDesktop.matches) { applyStatic(); return; }
    waitForGsap(buildST);
  }

  var tries = 0;
  function waitForGsap(cb) {
    if (window.gsap && window.ScrollTrigger) { cb(); return; }
    if (tries++ > 60) { applyStatic(); return; }
    setTimeout(function () { waitForGsap(cb); }, 50);
  }

  // vendored GSAP (load once, globally)
  function loadScript(src, flag) {
    if (window[flag]) return;
    window[flag] = true;
    var el = document.createElement('script');
    el.src = src;
    el.defer = true;
    document.head.appendChild(el);
  }
  loadScript(s.getAttribute('data-gsap-src'), '__vwGsapLoad');
  loadScript(s.getAttribute('data-st-src'), '__vwStLoad');

  decide();
  if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', function () { tries = 0; decide(); });
  window.addEventListener('resize', function () { if (st) st.refresh(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vw-home-intro-statement"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var nodes = document.querySelectorAll('.vw-home-intro-statement [data-statement]:not(.vw-his-bound)');
    for (var n = 0; n < nodes.length; n++) {
      (function (p) {
        p.classList.add('vw-his-bound');
        var text = (p.textContent || '').replace(/\s+/g, ' ').trim();
        if (!text) return;
        // Reduced motion / no rAF: leave plain text fully visible.
        if (reduce || !('requestAnimationFrame' in window)) return;

        p.setAttribute('aria-label', text);
        p.textContent = '';
        var spans = [];
        for (var i = 0; i < text.length; i++) {
          var s = document.createElement('span');
          s.className = 'vw-char';
          var ch = text.charAt(i);
          if (ch === ' ') { s.className += ' is-space'; s.textContent = ' '; }
          else s.textContent = ch;
          s.setAttribute('aria-hidden', 'true');
          s.style.opacity = '0.16';
          p.appendChild(s);
          spans.push(s);
        }
        var total = spans.length;
        var ticking = false;

        function update() {
          ticking = false;
          var rect = p.getBoundingClientRect();
          var vh = window.innerHeight || document.documentElement.clientHeight;
          // Framer offset ["start 0.82","end 0.28"]:
          //   progress 0 when p.top = 0.82*vh; progress 1 when p.bottom = 0.28*vh.
          var denom = (0.54 * vh) + rect.height;
          var progress = denom > 0 ? ((0.82 * vh) - rect.top) / denom : 0;
          if (progress < 0) progress = 0; else if (progress > 1) progress = 1;
          for (var i = 0; i < total; i++) {
            var start = (i / total) * 0.85;
            var end = Math.min(1, start + 0.15);
            var local = end > start ? (progress - start) / (end - start) : 1;
            if (local < 0) local = 0; else if (local > 1) local = 1;
            spans[i].style.opacity = (0.16 + 0.84 * local).toFixed(3);
          }
        }
        function onScroll() {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(update);
        }
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        update();
      })(nodes[n]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vw-kennels-sizes"] && !Shopify.designMode) return;
  try {
    
(function () {
  var s = (document.currentScript && document.currentScript.closest('.vw-kennels-sizes')) || document.querySelector('.vw-kennels-sizes');
  if (!s) return;

  // Below 460px the grid becomes a horizontal snap row (CSS .is-swipe). A
  // scroll container has to be reachable by keyboard (WCAG 2.1.1 Keyboard), so
  // give it a tab stop and a group role — but only while it actually scrolls,
  // otherwise the desktop grid picks up a pointless tab stop.
  var grid = s.querySelector('[data-ksz-grid]');
  if (grid && grid.classList.contains('is-swipe') && window.matchMedia) {
    var mq = window.matchMedia('(max-width: 459.98px)');
    var syncSwipe = function () {
      if (mq.matches) {
        grid.setAttribute('tabindex', '0');
        grid.setAttribute('role', 'group');
      } else {
        grid.removeAttribute('tabindex');
        grid.removeAttribute('role');
      }
    };
    syncSwipe();
    if (mq.addEventListener) mq.addEventListener('change', syncSwipe);
    else if (mq.addListener) mq.addListener(syncSwipe);
  }

  s.addEventListener('click', function (e) {
    var fav = e.target.closest('[data-vw-fav]');
    if (fav && s.contains(fav)) {
      fav.setAttribute('aria-pressed', fav.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      return;
    }
    var link = e.target.closest('[data-vw-quickview]');
    if (!link || !s.contains(link)) return;
    var handle = link.getAttribute('data-handle');
    if (!handle) return;
    // Cancelable quick-view event: a quick-view handler calls preventDefault(),
    // which suppresses the link navigation. With no handler the <a> falls back
    // to the product page.
    var ev = new CustomEvent('vw:quickview', { detail: { handle: handle }, bubbles: true, cancelable: true });
    if (!link.dispatchEvent(ev)) { e.preventDefault(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vw-product-main"] && !Shopify.designMode) return;
  try {
    
(function () {
  var s = (document.currentScript && document.currentScript.closest('.vw-product-main')) || document.querySelector('.vw-product-main');
  if (!s) return;

  // gallery thumbs
  var main = s.querySelector('[data-vw-pm-main]');
  s.querySelectorAll('[data-vw-pm-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      if (main) main.src = t.getAttribute('data-full');
      s.querySelectorAll('[data-vw-pm-thumb]').forEach(function (o) { o.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  // quantity stepper
  var qty = 1;
  var qtyVal = s.querySelector('[data-vw-pm-qtyval]');
  var qtyInput = s.querySelector('[data-vw-pm-qtyinput]');
  s.querySelectorAll('[data-vw-pm-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      qty = Math.max(1, qty + parseInt(b.getAttribute('data-vw-pm-qty'), 10));
      if (qtyVal) qtyVal.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
    });
  });

  // variant option chips -> mirror into hidden <select name="id">
  var select = s.querySelector('[data-vw-pm-variant]');
  var selected = [];
  s.querySelectorAll('[data-vw-pm-opt]').forEach(function (chip) {
    var idx = parseInt(chip.getAttribute('data-vw-pm-opt'), 10);
    if (chip.classList.contains('is-active')) selected[idx] = chip.getAttribute('data-val');
  });
  function syncVariant() {
    if (!select) return;
    var opts = select.querySelectorAll('option');
    // Shopify option titles join with " / " in variant.title
    var want = selected.join(' / ');
    for (var i = 0; i < opts.length; i++) {
      if (opts[i].textContent.trim() === want) {
        select.selectedIndex = i;
        var priceEl = s.querySelector('[data-vw-pm-price]');
        if (priceEl && opts[i].getAttribute('data-price')) priceEl.textContent = opts[i].getAttribute('data-price');
        break;
      }
    }
  }
  s.querySelectorAll('[data-vw-pm-group], .vw-product-main__group').forEach(function (group) {
    group.querySelectorAll('[data-vw-pm-opt]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var idx = parseInt(chip.getAttribute('data-vw-pm-opt'), 10);
        selected[idx] = chip.getAttribute('data-val');
        group.querySelectorAll('[data-vw-pm-opt]').forEach(function (o) {
          o.classList.remove('is-active');
          o.setAttribute('aria-pressed', 'false');
        });
        chip.classList.add('is-active');
        chip.setAttribute('aria-pressed', 'true');
        var nameEl = group.querySelector('[data-vw-pm-selname]');
        if (nameEl) nameEl.textContent = chip.getAttribute('data-val');
        syncVariant();
      });
    });
  });

  // accordions
  s.querySelectorAll('[data-vw-pm-accord]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      var body = btn.nextElementSibling;
      body.style.maxHeight = expanded ? '0px' : (body.scrollHeight + 20) + 'px';
    });
  });

  // progressive-enhance add-to-cart: AJAX + open drawer (React parity).
  var form = s.querySelector('.vw-product-main__form');
  if (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; // let it submit normally
      e.preventDefault();
      var btn = form.querySelector('[data-vw-pm-add]');
      if (btn && btn.disabled) return;
      if (btn) btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json(); })
        .then(function () { document.dispatchEvent(new CustomEvent('vw:cart-changed')); })
        .catch(function () { form.submit(); })
        .then(function () { if (btn) btn.disabled = false; });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vw-search"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.vw-search');
  if (!root || root.hasAttribute('data-vw-bound')) return;
  root.setAttribute('data-vw-bound', '');

  function listAttr(el, name) {
    var raw = el.getAttribute(name);
    if (!raw) return null;
    var out = raw.split('||').filter(Boolean);
    return out.length ? out : null;
  }

  // Same quick-view hand-off as the collection product bands: metafields ride
  // on the card because /products/<handle>.js cannot return them.
  Array.prototype.forEach.call(root.querySelectorAll('[data-card]'), function (card) {
    var media = card.querySelector('[data-quickview]');
    if (!media) return;
    media.addEventListener('click', function (e) {
      var gallery = null;
      var raw = card.getAttribute('data-species-gallery');
      if (raw) { try { gallery = JSON.parse(raw); } catch (err) { gallery = null; } }
      var ev = new CustomEvent('vw:quickview', {
        detail: {
          handle: media.getAttribute('data-quickview'),
          meta: {
            category: card.getAttribute('data-category') || '',
            maker: card.getAttribute('data-maker') || '',
            provenance: card.getAttribute('data-provenance') || '',
            dimensions: card.getAttribute('data-dimensions') || '',
            leadTime: card.getAttribute('data-lead-time') || '',
            materials: listAttr(card, 'data-materials'),
            finishes: listAttr(card, 'data-finishes'),
            speciesGallery: gallery,
            comingSoon: card.getAttribute('data-coming-soon') === '1'
          }
        },
        cancelable: true,
        bubbles: true
      });
      if (!document.dispatchEvent(ev)) e.preventDefault();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vw-woodsmiths-apply"] && !Shopify.designMode) return;
  try {
    
(function () {
  var s = (document.currentScript && document.currentScript.closest('.vw-woodsmiths-apply')) || document.querySelector('.vw-woodsmiths-apply');
  if (!s) return;
  var form = s.querySelector('[data-vw-apply-form]');
  if (!form) return;
  var input = form.querySelector('[data-vw-apply-email]');
  var label = form.querySelector('[data-vw-apply-label]');
  var icon = form.querySelector('[data-vw-apply-icon]');
  var btn = form.querySelector('[data-vw-apply-submit]');
  var note = form.querySelector('[data-vw-apply-note]');

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (form.classList.contains('is-sent')) return;
    if (!input || !input.value || input.value.indexOf('@') === -1) return;
    form.classList.add('is-sent');
    if (label && btn) label.textContent = btn.getAttribute('data-sent-label') || label.textContent;
    if (icon) icon.setAttribute('hidden', '');
    if (note) note.textContent = note.getAttribute('data-sent-text') || note.textContent;
  });
})();

  } catch(e) { console.error(e); }
})();
})();
